import React, { useState, useEffect } from 'react';
import SitemapService from '../utils/sitemap';
import { publicAPI } from '../services/api';

const Sitemap = ({ format = 'html' }) => {
  const [sitemapXml, setSitemapXml] = useState('');
  const [robotsTxt, setRobotsTxt] = useState('');
  const [routes, setRoutes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDataAndGenerateSitemap = async () => {
      try {
        // Fetch TCG data
        const response = await publicAPI.getEndpoints();
        let supportedTcgs = [];

        if (response.data.success) {
          supportedTcgs = response.data.data.supported_tcgs || [];
        }

        // Generate sitemap with TCG data
        const xml = await SitemapService.generateSitemap(window.location.origin, supportedTcgs);
        const robots = SitemapService.generateRobotsTxt();
        const routeMetadata = SitemapService.getRouteMetadata(supportedTcgs);

        setSitemapXml(xml);
        setRobotsTxt(robots);
        setRoutes(routeMetadata);
      } catch (error) {
        console.error('Error generating sitemap:', error);
        // Fallback to basic sitemap without TCG data
        const xml = await SitemapService.generateSitemap();
        const robots = SitemapService.generateRobotsTxt();
        const routeMetadata = SitemapService.getRouteMetadata();

        setSitemapXml(xml);
        setRobotsTxt(robots);
        setRoutes(routeMetadata);
      } finally {
        setLoading(false);
      }
    };

    fetchDataAndGenerateSitemap();
  }, []);

  if (format === 'xml') {
    // Return raw XML for /sitemap.xml route
    return (
      <div style={{ whiteSpace: 'pre-wrap', fontFamily: 'monospace' }}>
        {sitemapXml}
      </div>
    );
  }

  if (format === 'robots') {
    // Return raw robots.txt for /robots.txt route
    return (
      <div style={{ whiteSpace: 'pre-wrap', fontFamily: 'monospace' }}>
        {robotsTxt}
      </div>
    );
  }

  // Default HTML format for user-friendly display
  return (
    <div className="max-w-4xl mx-auto space-y-8">
      <div>
        <h1 className="text-3xl font-bold text-gray-900">Sitemap</h1>
        <p className="text-gray-600 mt-2">
          All publicly accessible pages on the TCG API website.
        </p>
      </div>

      {loading && (
        <div className="text-center py-8">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500 mx-auto"></div>
          <p className="text-gray-600 mt-2">Loading sitemap...</p>
        </div>
      )}

      {!loading && (
        <>
      {/* Site Pages */}
      <div className="card p-6">
        <h2 className="text-xl font-bold text-gray-900 mb-6">Site Pages</h2>
        <div className="space-y-4">
          {routes.map((route, index) => (
            <div key={index} className="border border-gray-200 rounded-lg p-4">
              <div className="flex items-center justify-between mb-2">
                <a
                  href={route.path}
                  className="text-blue-600 hover:text-blue-800 font-medium"
                >
                  {route.path === '/' ? 'Home' : route.path}
                </a>
                <span className="text-xs text-gray-500 font-mono">
                  {window.location.origin}{route.path}
                </span>
              </div>
              <h3 className="font-medium text-gray-900 mb-1">{route.title}</h3>
              <p className="text-gray-600 text-sm mb-2">{route.description}</p>
              <div className="flex flex-wrap gap-2">
                {route.keywords.split(', ').map((keyword, keyIndex) => (
                  <span
                    key={keyIndex}
                    className="bg-gray-100 text-gray-700 px-2 py-1 rounded text-xs"
                  >
                    {keyword}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
        </>
      )}
    </div>
  );
};

export default Sitemap;